import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import { connect } from "react-redux";
import api from "../../utility/api/api.js";
import OrderInTransit from "./ViewTripList/OrderInTransit";
import DelayReason from "./ViewTripList/DelayReason";
import DelayReport from "./ViewTripList/DelayReport";
import HoldReasons from "./ViewTripList/HoldReasons";
import TripDetail from "./ViewTripList/TripDetail";
import {
  actionProcessingJobs,
  completedJobsAction,
  delayOrderAction,
} from "../../actions/index";
import { bindActionCreators } from "redux";
import GetTime from "../GetTime.js";
import { Row, Col } from "reactstrap";
import { notify } from "react-notify-toast";
import notification from "../../images/notifications_white.svg";
import loader from "../../images/loader.gif";

class IntransitDataComponent extends Component {
  constructor(props) {
    super(props);
    console.log("chkdd", this.props);
    localStorage.getItem("ordersArr") && localStorage.removeItem("ordersArr");
    this.state = { isEndTripLoading: false };
  }

  componentDidMount() {
    // document.getElementById("mainHeader").classList.add("displayNone");
    document.getElementById("header-nav-bar").classList.add("displayNone");
  }
  // componentWillReceiveProps() {
  //   this.props.trips &&
  //     document.getElementById("header-nav-bar").classList.add("displayNone");
  // }

  // componentWillMount() {
  //   api.callAssignedJobs(this, "in-transit");
  // }

  async endtrip(trip_id, e) {
    const completedOrders = this.props.trips.job.completed_orders
      ? this.props.trips.job.completed_orders
      : 0;
    if (this.props.trips.job.order_count != completedOrders) {
      notify.show("please complete all the jobs", "error", 2000);
      e.preventDefault();
    } else {
      this.setState({ isEndTripLoading: true });
      await api.endTrip(trip_id, this);
      this.setState({ isEndTripLoading: false });
    }
  }

  render() {
    const data = this.props.trips;
    console.log("renderRenderrrrrrrrrrrrrrr::::::", data);

    return (
      <div>
        <div className="inTransitHeader">
          <NavLink to="/">
            <i className="text-white float-left pt-1 pr-3 icon-prevarrow back-btn-arrow"></i>
          </NavLink>
          <span className="inTransitHeaderTitle">
            <span>JID:</span> {data.job.job_id}
          </span>
          <img
            className="float-right pt-1"
          // src={notification}
          // alt="notification"
          />
        </div>
        <div>
          {/*complete order detail header*/}
          {/* <div className="job_id">
          <div className="container">
            <span>Trip ID:</span> {data.job.job_id}
          </div>
        </div> */}
          <div className="trip_detail_container">
            <div className="container">
              <Row className="trip_details">
                <Col className="first trips_inner_details">
                  Orders: <p>{data.job.order_count}</p>
                </Col>
                <Col className="trips_inner_details">
                  Completed: <p>{data.job.completed_orders}</p>
                </Col>
                <Col className="trips_inner_details">
                  Assigned:{" "}
                  <p className="remove-padding">
                    <GetTime time={data.job.assigned_at} />
                  </p>
                </Col>
                {/* <Col className="last trips_inner_details">
                  Finish by:{" "}
                  <p className="remove-padding">
                    <GetTime time={data.job.delivered_by} />
                  </p>
                </Col> */}
              </Row>
            </div>
          </div>
          {/*Trip detail*/}
          {data.orders &&
            data.orders.map((obj, k) => (
              <OrderInTransit
                key={k}
                trip_id={data.job.job_id}
                orderData={obj}
                index={k + 1}
              />
            ))}{" "}
          {/* <TripDetail tripDetailView={data.trip_detail} /> */}
          <div className="tripTitle">TRIP SUMMARY</div>
          <div className="tripDetails">
            Orders: {data.orders ? data.orders.length : 0}
          </div>
          { }

          {parseFloat(data.job.amount_to_be_collected) > 0
            ? (<div className="tripDetails">
              Amount Due:{" "}  {data.job.amount_to_be_collected}</div>)
            : null}


          {parseFloat(data.job.amount_collected_card) > 0
            ? (
              <div className="tripDetails">
                Amount collected by Card 1:{" "}
                {data.job.amount_collected_card}
              </div>
            ) : null}

          {parseFloat(data.job.amount_collected_card_2) > 0
            ? (
              <div className="tripDetails">
                Amount collected by Card 2:{" "}
                {data.job.amount_collected_card_2}
              </div>
            ) : null}


          {parseFloat(data.job.amount_collected_card_3) > 0
            ? (
              <div className="tripDetails">
                Amount collected by Card 3:{" "}
                {data.job.amount_collected_card_3}
              </div>
            ) : null}


          {parseFloat(data.job.amount_collected_cash) > 0
            ? (
              <div className="tripDetails">
                Amount colledted by Cash:{" "}
                {data.job.amount_collected_cash}
              </div>
            )
            : null}

          {parseFloat(data.job.amount_collected_on_credit) > 0
            ? (
              <div className="tripDetails">
                Amount colledted by On Credit:{" "}
                {data.job.amount_collected_on_credit}
              </div>
            )
            : null}

          {parseFloat(data.job.amount_collected_benefit_pay) > 0
            ? (
              <div className="tripDetails">
                Amount colledted by Benefit Pay:{" "}
                {data.job.amount_collected_benefit_pay}
              </div>
            )
            : null}

          {parseFloat(data.job.amount_collected_store_credit) > 0
            ? (
              <div className="tripDetails">
                Amount colledted by Store Credit:{" "}
                {data.job.amount_collected_store_credit}
              </div>
            )
            : null}
          {parseFloat(data.job.amount_collected_bmmi_ala) > 0
            ? (
              <div className="tripDetails">
                Amount colledted by BMMI ALA:{" "}
                {data.job.amount_collected_bmmi_ala}
              </div>
            )
            : null}
          {parseFloat(data.job.amount_collected_round_off) > 0
            ? (
              <div className="tripDetails">
                Amount colledted by Round Off:{" "}
                {data.job.amount_collected_round_off}
              </div>
            )
            : null}
          {parseFloat(data.job.amount_collected_short_paid) > 0
            ? (
              <div className="tripDetails">
                Amount colledted by Short Paid:{" "}
                {data.job.amount_collected_short_paid}
              </div>
            )
            : null}
          {this.props &&
            this.props.delayorderData &&
            this.props.delayorderData.length ? (
            <DelayReport delayReport={this.props.delayorderData} />
          ) : (
            ""
          )}
          <div className="container">
            <Row className="end_trip_mark_delay_btn_container pl-0 pr-0">
              {/* <div className="col-4 btn_end_trip"> */}
              <DelayReason
                ordercompleted={
                  data.job.order_count === data.job.completed_orders
                }
                trip_id={data.job.job_id}
                label="Delay"
              />
              {/* </div> */}
              {this.state.isEndTripLoading ? (
                <img src={loader} height="50px" />
              ) : (
                <div className="endTripBtn">
                  <NavLink
                    to="/completed"
                    onClick={(e) => this.endtrip(data.job.job_id, e)}
                  // className="spn-jobs-decisionbutton btn spn-jobs-decisionbutton-cancel orange-btn"
                  >
                    END TRIP
                  </NavLink>
                </div>
              )}
              {/* <div className="col-4 btn_end_trip">
                <HoldReasons trip_id={data.job.job_id} label="Hold" />
              </div> */}
            </Row>
          </div>
        </div>
      </div>
    );
  }
  componentWillUnmount() {
    // document.getElementById("mainHeader").classList.add("displayNone");
    // document.getElementById("headerSwitch").classList.add("displayNone");
  }
}

function mapStateToProps(state) {
  console.log("delayorderDetails", state);
  return {
    delayorderData: state.getdelayorders,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      actionProcessingJobs: actionProcessingJobs,
      completedJobsAction: completedJobsAction,
      delayOrderAction: delayOrderAction,
    },
    dispatch
  );
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(IntransitDataComponent);



// WEBPACK FOOTER //
// ./src/components/Intransit/IntransitDataComponent.js